import training from './training'

export default training
